<script setup lang="ts">
/**
 * App-shaped placeholder while the session and workspace start. Same markup as
 * the static copy in index.html (styles live there too), so the first paint,
 * the auth check and the app shell blend into each other without a blank page.
 */
defineProps<{ label?: string }>();
</script>

<template>
  <div class="boot-skeleton" role="status" :aria-label="label || 'Moonshot wird geladen'">
    <header class="boot-skeleton__header">
      <span class="boot-skeleton__brand"><i /><i /><i /></span>
      <span class="boot-skeleton__nav"><b /><b /><b /><b /></span>
      <span class="boot-skeleton__tools"><b /><b /><i /></span>
    </header>
    <div class="boot-skeleton__body">
      <aside class="boot-skeleton__sidebar">
        <b class="is-title" /><b class="is-search" />
        <span class="boot-skeleton__chips"><b /><b /><b /></span>
        <div class="boot-skeleton__rows"><div v-for="row in 7" :key="row"><i /><span><b /><b /></span></div></div>
      </aside>
      <main class="boot-skeleton__map"><span class="boot-skeleton__pill"><i />{{ label || 'Moonshot wird geladen …' }}</span></main>
    </div>
  </div>
</template>
